export const notificationMessage = {
    resendCodeLimit: 'Zbyt wiele próśb o kod. Zaczekaj 5 minut i spróbuj ponownie.',
};
